const name = "appSettings";

export const getAppSettings = () => JSON.parse(localStorage.getItem(name));

export const setAppSettings = (newSettings) => {
    if(newSettings)
        localStorage.setItem(name, JSON.stringify(newSettings));
};

export const mergeToAppSettings = (data = {}) => {
    const current = getAppSettings();
    data = {
        ...current,
        ...data,
    };
    setAppSettings(data);
};

export const deleteFromAppSettings = (field) => {
    const current = getAppSettings();
    if(current[field])
        delete current[field];
    setAppSettings(current);
};

export const updateFromAppSettings = (field, newValue) => {
    if(field && newValue) {
        const current = getAppSettings();
        current[field] = (typeof(newValue) == 'object')? JSON.stringify(newValue) : newValue;
        setAppSettings(current);
    }
};

export const purgeAppSettings = () => {
    setAppSettings({});
};

export const getRestaurantSettingsForm = (restaurantSettings) => {
    return {
        id: {value: restaurantSettings.id, modified: false, type: "id", valid: true},
        name: {value: restaurantSettings.name, modified: false, type: "not_empty_string", valid: false},
        address: {value: restaurantSettings.address, modified: false, type: "not_empty_string", valid: false},
        phone: {value: restaurantSettings.phone, modified: false, type: "phone_or_nothing", valid: false},
        email: {value: restaurantSettings.email, modified: false, type: "email_or_nothing", valid: false},
        website: {value: restaurantSettings.website, modified: false, type: "url", valid: false},
        general_message: {value: restaurantSettings.general_message, modified: false, type: "terrace_message", valid: true},
        show_general_message: {value: restaurantSettings.show_general_message, modified: false, type: "boolean", valid: true},
        latitude: {value: restaurantSettings.latitude, modified: false, type: "latitude", valid: true},
        longitude: {value: restaurantSettings.longitude, modified: false, type: "longitude", valid: true},
        zoom: {value: restaurantSettings.zoom, modified: false, type: "zoom", valid: true},
        logo: {value: restaurantSettings.logo, modified: false, type: "image", valid: true},
        banner: {value: restaurantSettings.banner, modified: false, type: "image", valid: true},
        online: {value: restaurantSettings.online, modified: false, type: "boolean", valid: true},
        reservation_duration: {value: restaurantSettings.reservation_duration, modified: false, type: "positive_duration", valid: true},
        reservation_before_duration: {value: restaurantSettings.reservation_before_duration, modified: false, type: "duration", valid: true},
        reservation_time_window : {value: restaurantSettings.reservation_time_window, modified: false, type: "duration_or_nothing", valid: true},
        duration_before_service: {value: restaurantSettings.duration_before_service, modified: false, type: "boolean", valid: true},
        show_cake: {value: restaurantSettings.show_cake, modified: false, type: "boolean", valid: true},
        cake_before_duration: {value: restaurantSettings.cake_before_duration, modified: false, type: "duration", valid: true},
        show_stroller: {value: restaurantSettings.show_stroller, modified: false, type: "boolean", valid: true},
        show_highchair: {value: restaurantSettings.show_highchair, modified: false, type: "boolean", valid: true},
        show_reduced_mobility: {value: restaurantSettings.show_reduced_mobility, modified: false, type: "boolean", valid: true},
        show_terrace: {value: restaurantSettings.show_terrace, modified: false, type: "boolean", valid: true},
        show_meal_types: {value: restaurantSettings.show_meal_types, modified: false, type: "boolean", valid: true},
        show_children_count: {value: restaurantSettings.show_children_count, modified: false, type: "boolean", valid: true},
        terrace_message: {value: restaurantSettings.terrace_message, modified: false, type: "terrace_message", valid: true},
        auto_confirm_active: { value: restaurantSettings.auto_confirm_active, modified: false, type: "boolean", valid: true },
        reservation_cancellation_limit_enabled: { value: restaurantSettings.reservation_cancellation_limit_enabled ?? false, modified: false, type: "boolean", valid: true },
        reservation_cancellation_limit: {value: restaurantSettings.reservation_cancellation_limit, modified: false, type: "duration", valid: true},
        reservation_cancellation_limit_before_shift: { value: restaurantSettings.reservation_cancellation_limit_before_shift ?? false, modified: false, type: "boolean", valid: true },
    }
};


// WEBPACK FOOTER //
// ./src/helpers/settings.js